$(() => {
  let divsTextCare = document.querySelectorAll(".text-care");

  for (i = 0; i < divsTextCare.length; i++) {
    divsTextCare[i].classList.add("hideDivCare");
  }

  if ($(window).width() < 900) {
    $(".plus-space").css("--myVar", "rotate(45deg)");

    let divH2Care = document.querySelectorAll(".heading-care");
    let optionTag = document.getElementById("sel");
    let select = document.querySelector("select");
    let firstClick = 0;

    select.addEventListener("change", (e) => {
      for (i = 0; i < optionTag.length; i++) {
        if (optionTag.options[i].selected) {
          firstClick++;
        }

        if (optionTag.options[i].selected && firstClick > 0) {
          divsTextCare[i].classList.remove("hideDivCare");
          let optionSelected = optionTag.options[i].id;
          let targetElement = document.getElementById(
            optionSelected + "_question"
          );
          targetElement.scrollIntoView({ behavior: "smooth", block: "start" });
          divH2Care[i].classList.add("active");
          $(".active .plus-space").css("--myVar", "rotate(0deg)");
        }
      }
    });

    let plusSelector = document.querySelectorAll(".plus-space");

    plusSelector.forEach((element) => {
      element.addEventListener("touchstart", (e) => {
        let divH2Care = document.querySelectorAll(".heading-care");
        let elementNameProduct = element.getAttribute("product");
        for (i = 0; i < divH2Care.length; i++) {
          if (
            elementNameProduct == divH2Care[i].textContent.trim() &&
            divH2Care[i].className == "heading-care active"
          ) {
            $(".plus-space").css("--myVar", "rotate(45deg)");
          }
        }

        for (i = 0; i < divH2Care.length; i++) {
          if (elementNameProduct == divH2Care[i].textContent.trim()) {
            divH2Care[i].classList.toggle("active");
            divH2Care[i].nextElementSibling.classList.toggle("hideDivCare");
          }
        }

        for (i = 0; i < divH2Care.length; i++) {
          if (elementNameProduct == divH2Care[i].textContent.trim()) {
            $(".active .plus-space").css("--myVar", "rotate(0deg)");
          }
        }
      });
    });

    function fnBrowserDetect() {
      let userAgent = navigator.userAgent;

      if (userAgent.match(/chrome|chromium|crios/i)) {
        return;
      } else if (userAgent.match(/safari/i)) {
        document.getElementById("container-info").style.display = "none";
        let containerCareRecommendations = document.querySelector(
          ".container-care-recomendations"
        );

        containerCareRecommendations.style.gridTemplateColumns = "auto";
      }
    }
    fnBrowserDetect();
  }

  if ($(window).width() > 900) {
    $(".plus-space").css("--myVar", "rotate(45deg)");

    let objectLength = document.querySelectorAll("select option").length;

    $("select").attr("size", objectLength);

    addEventListener("click", (e) => {
      let divH2Care = document.querySelectorAll(".heading-care");
      let divH2Info = document.querySelectorAll("option");
      let divTextCare = document.querySelectorAll(".text-care");
      let parentNode = e.target.parentNode;
      let classParentOfParentNode = parentNode.parentNode.className;

      for (i = 0; i < divH2Care.length; i++) {
        if (
          e.target.innerText == divH2Care[i].textContent.trim() &&
          divH2Care[i].className ==
            "heading-care active heading-care-shadow-hover"
        ) {
          $(".plus-space").css("--myVar", "rotate(45deg)");
        }
      }

      for (i = 0; i < divH2Care.length; i++) {
        if (e.target.innerText == divH2Care[i].textContent.trim()) {
          divH2Care[i].classList.toggle("active");
          divH2Care[i].nextElementSibling.classList.toggle("hideDivCare");
        }

        if (
          e.target.innerText == divH2Care[i].textContent.trim() &&
          classParentOfParentNode == "container-info-care"
        ) {
          divH2Care[i].classList.add("active");
          divH2Care[i].nextElementSibling.classList.remove("hideDivCare");
        }

        if (e.target.innerText == divH2Care[i].textContent.trim()) {
          divH2Care[i].classList.toggle("heading-care-shadow-hover");
          divTextCare[i].classList.toggle("text-care-shadow-hover");
        }

        if (
          e.target.innerText == divH2Care[i].textContent.trim() &&
          e.classParentOfParentNode == "container-info-care"
        ) {
          divH2Care[i].classList.add("heading-care-shadow-hover");
          divTextCare[i].classList.add("text-care-shadow-hover");
        }
      }

      for (i = 0; i < divH2Care.length; i++) {
        if (e.target.innerText == divH2Care[i].textContent.trim()) {
          $(".active .plus-space").css("--myVar", "rotate(0deg)");
        }
      }

      if (classParentOfParentNode == "container-info-care") {
        let targetElement = document.getElementById(e.target.id + "_question");
        targetElement.scrollIntoView({ behavior: "smooth", block: "start" });
      }
    });

    function fnBrowserDetect() {
      let userAgent = navigator.userAgent;

      if (userAgent.match(/chrome|chromium|crios/i)) {
        return;
      } else if (userAgent.match(/safari/i)) {
        document.getElementById("container-info").style.display = "none";
        let containerCareRecommendations = document.querySelector(
          ".container-care-recomendations"
        );

        containerCareRecommendations.style.gridTemplateColumns = "auto";
      }

      fnBrowserDetect();
    }
    fnBrowserDetect();
  }
});
